// src/pages/SubscribeButton.jsx
import React, { useState } from "react";
import api from "../api/api"; // axios instance pointing to http://localhost:5001/api

export default function SubscribeButton() {
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (plan) => {
    try {
      setLoading(true);
      const { data } = await api.post("/payments/create-order", { plan });

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID, // from your .env
        amount: data.amount,
        currency: data.currency,
        name: "Interview Tracker",
        description: `${plan.toUpperCase()} Plan Subscription`,
        order_id: data.id,
        handler: async function (response) {
          try {
            await api.post("/payments/verify", {
              orderId: data.id,
              paymentId: response.razorpay_payment_id,
              signature: response.razorpay_signature,
              plan,
            });
            alert(`✅ ${plan.toUpperCase()} subscription successful!`);
          } catch (err) {
            console.error("Verification failed", err);
            alert("❌ Payment verification failed");
          }
        },
        prefill: {
          name: "Your Name",
          email: "you@example.com",
          contact: "9999999999",
        },
        theme: { color: "#3399cc" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error("Payment error:", error.response?.data || error.message);
      alert(error.response?.data?.error || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center gap-4 mt-8">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Choose Your Plan</h2>

      <button
        onClick={() => handleSubscribe("basic")}
        disabled={loading}
        className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-6 rounded-lg shadow-md transition disabled:opacity-50"
      >
        {loading ? "Processing..." : "Subscribe Basic"}
      </button>

      <button
        onClick={() => handleSubscribe("pro")}
        disabled={loading}
        className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-6 rounded-lg shadow-md transition disabled:opacity-50"
      >
        {loading ? "Processing..." : "Subscribe Pro"}
      </button>
    </div>
  );
}
